/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tenant_Selection_Selectprompt1Inputs */

const es_tenant_selection_selectprompt1 = /** @type {(inputs: Tenant_Selection_Selectprompt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccioná el tenant al que querés ingresar`)
};

const en_tenant_selection_selectprompt1 = /** @type {(inputs: Tenant_Selection_Selectprompt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select the tenant you want to access`)
};

/**
* | output |
* | --- |
* | "Select the tenant you want to access" |
*
* @param {Tenant_Selection_Selectprompt1Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tenant_selection_selectprompt1 = /** @type {((inputs?: Tenant_Selection_Selectprompt1Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tenant_Selection_Selectprompt1Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tenant_selection_selectprompt1(inputs)
	return en_tenant_selection_selectprompt1(inputs)
});
export { tenant_selection_selectprompt1 as "tenant-selection.selectPrompt" }